export default __webpack_public_path__ + "static/media/faHome.47a850b6.png";